module.exports = __webpack_public_path__ + "img/26_132.da91c55f.png";